<template>
	<v-app-bar app color="primary">
		<div class="d-flex align-center">
			<router-link :to="admin ? {name: 'dashboard'} : {name: 'login'}">
				<v-img
					alt="Naltio Logo"
					class="shrink ml-3"
					contain
					src="../../assets/logos/inverted.svg"
					transition="scale-transition"
					width="50"
				/>
			</router-link>
		</div>
		<Breadcrumbs v-if="admin" :items="items" :solo="true" />
		<v-spacer></v-spacer>
		<v-btn v-if="loginPage" text :to="{name: 'register'}">
			<span class="white--text" v-translate key="register">Register</span>
			<v-icon></v-icon>
		</v-btn>
		<v-btn v-if="(registerPage||landingPage)" text :to="{name: 'login'}">
			<span class="white--text" v-translate key="login">Login</span>
			<v-icon></v-icon>
		</v-btn>
		<v-btn v-if="admin" text @click="logout">
			<span class="mr-2 white--text" v-translate key="logout">Logout</span>
			<v-icon></v-icon>
		</v-btn>
		<v-menu v-if="!admin" bottom offset-y>
			<template v-slot:activator="{ on }">
				<v-btn color="white" text v-on="on">
					{{currentLanguage}}
					<v-icon x-small>mdi-chevron-down</v-icon>
				</v-btn>
			</template>
			<v-list nav dense>
				<v-list-item-group v-model="currentLanguage" mandatory>
					<v-list-item v-for="l in availableLanguages" :key="l.code" :value="l.code" @click="changeLanguage(l.code)">
						<v-list-item-title>{{ l.name }}</v-list-item-title>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-menu>
	</v-app-bar>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
	name: "NavBar",
	components: {
		Breadcrumbs
	},
	props: ["loginPage", "registerPage", "landingPage", "admin", "items"],
	data: () => ({
		availableLanguages: [
			{ code: "pt", name: "Português" },
			{ code: "en", name: "English" }
		],
		currentLanguage: null
	}),
	methods: {
		logout() {
			this.$store
				.dispatch("LOGOUT")
				.then(response => {
					console.log(response);
					this.$router.push("/admin").then(this.$store.dispatch("REMOVE_USER"));
				})
				.catch(error => {
					console.log(error);
				});
		},
		changeLanguage(lang) {
			this.currentLanguage = lang;
			this.$store.dispatch("UPDATE_LANGUAGE", lang);
			this.$emit('change-language');
		}
	},
	created() {
		this.currentLanguage = this.$store.getters.userLanguage;
	}
};
</script>